{
  "withSubscribe": {
    "emptyCIS": "Пустой список CI",
    "connecting": "Подключаюсь..."
  },
  "TestWidget": {
    "title": "Тестовый widget",
    "description": "Тестовый widget"
  },
  "AlertWidget": {
    "title": "Лист тревог",
    "description": "Список последних тревог",
    "columns": {
      "name": "Название",
      "severity": "Статус",
      "alert": "Тревога",
      "start": "Начало",
      "end": "Конец"
    }
  },
  "TitleProps": {
    "title": "Настройки заголовка",
    "ellipsis": "Обрезать текст",
    "size": "Размер текста"
  },
  "Chord": {
    "title": "Хорда",
    "description": "Хорда"
  },
  "Sankey": {
    "title": "Санкей",
    "description": "Санкей"
  },
  "SovJsonWidget": {
    "title": "Отображение правил СОВ",
    "description": "Отображение правил СОВ"
  },
  "PieCharts": {
    "title": "Круговая диаграмма",
    "description": "Отображаем агрегатную информацию"
  },
  "ChartWidget": {
    "title": "График",
    "description": "Отображение информации в виде графика"
  },
  "AreaWidget": {
    "title": "Диаграмма с областями",
    "description": "Отображение информации в виде процентного графика"
  },
  "TableWidget": {
    "title": "Таблица",
    "description": "Отображение информации в виде таблицы"
  },
  "TabsWidget": {
    "title": "Табы",
    "description": "Табы, из других widget"
  },
  "InfoWidget": {
    "title": "Hi статус",
    "description": "Блоки с статусами CI"
  },
  "ValueWidget": {
    "title": "Статус значения",
    "description": "Значения метрик с порогами"
  },
  "AttributesWidget": {
    "title": "Карточка с атрибутами",
    "description": "Атрибуты CI"
  },
  "CITreeWidget": {
    "title": "Дерево компонентов",
    "description": "Древо компонентов, с возможностью уточнения по CI/CIT"
  },
  "GaugeWidget": {
    "title": "Измеритель",
    "description": "Измеряет значения с диапазоном"
  },
  "Cytoscape": {
    "title": "Граф",
    "description": "Отображение TQL в виде графа"
  },
  "NewMetric": {
    "title": "Линейный график",
    "description": "Возможность отображать на графике до двух осей",
    "DataParser": {
      "Title": "Обработка данных",
      "metricQuery": "Запрос {{index}}",
      "cardTitle": {
        "0": "Ось значений",
        "1": "Дополнительная ось значений"
      },
      "query": "Запрос",
      "name": "Метрика"
    },
    "TimeFormat": {
      "Title": "Формат времени"
    }
  },
  "NewWidget": {},
  "config": {
    "TitleOption": {
      "title": "Заголовок",
      "placeholder": "Заголовок widget"
    },
    "ViewOption": {
      "title": "Способ отображения множества CI : ",
      "table": "Таблица",
      "tabs": "Табы",
      "grid": "Сетка"
    }
  },
  "options": {
    "TitleOption": "Заголовок",
    "FilterOption": "Фильтр",
    "ViewOption": "Способ отображения",
    "TabLabelOption": "Заголовок вкладок Таба",
    "GridLabel": "Заголовок ячеек",
    "SchemaConstructor": "Конструктор дерева",
    "AlertOptions": "Настройки",
    "CITDashboard": {
      "title": "Привязка Dashboard к CIT",
      "header": "Какой отрисовывать Дашборд при клике на CIT :",
      "single": "Один CI",
      "group": "Группа"
    },
    "ChartRewrite": {
      "title": "Перезапись осей"
    },
    "ChartAction": {
      "title": "Настройка событий",
      "add": "Добавить событие",
      "element": "Элемент",
      "event": "Событие",
      "action": "Действие"
    },
    "AreaConfig": {
      "title": "Настройка области"
    },
    "ChartParse": {
      "title": "Преобразование данных",
      "configTitle": "Источник названия",
      "group": "Группировка",
      "groupKey": "Ключ группировки",
      "groupView": "Способ отображения",
      "tabs": "Табы",
      "grid": "Сетка",
      "yes": "Да",
      "no": "Нет"
    },
    "StatusOverTime": {
      "Flags": {
        "title": "Настройки отображения",
        "main": "Статус CI",
        "second": "Индикатор здоровья"
      },
      "Delimiters": {
        "title": "Разделители"
      },
      "TimeSettings": {
        "title": "Настройки времени"
      }
    },
    "Table": {
      "Current": {
        "title": "Текущий CIT"
      },
      "General": {
        "title": "Общие настройки"
      },
      "Hidden": {
        "title": "Скрыть столбцы"
      },
      "Rewrite": {
        "title": "Перезапись столбца"
      }
    },
    "Gauge": {
      "Main": {
        "main": "Основные настройки",
        "thresholds": "Пороги",
        "from": "От",
        "to": "До",
        "Title": "Настройки",
        "base": "Базовое",
        "percent": "Проценты",
        "absolute": "Абсолютное"
      }
    },
    "AlertWidget": {
      "showHistory": "Показывать историю",
      "defaultSort": "Сортировка по умолчанию"
    }
  },
  "nodeWidth": {
    "title": "Настройка размеров",
    "nodeWidthRatio": "Ширина узла",
    "nodePaddingRatio": "Отступы между узлами",
    "small": "Маленький",
    "medium": "Средний",
    "large": "Большой"
  },
  "isInterval": {
    "title": "Настройка интервала",
    "label": "Последнее значение"
  },
  "chordMapper": {
    "title": "Маппер",
    "source": "Источник",
    "target": "Цель",
    "noSource": "Настройте Маппер -> Источник | Цель"
  },
  "chordRewrite": {
    "title": "Перезапись",
    "namePlaceholder": "Источник | Цель",
    "rewritePlaceholder": "Значение на перезапись"
  },
  "chartEvents": {
    "click": "Нажатие",
    "mousedown": "Зажата левая клавиша мыши",
    "mouseup": "Отжата левая клавиша мыши",
    "dblclick": "Двойное нажатие",
    "mouseenter": "mouseenter",
    "mouseout": "mouseout",
    "mouseover": "mouseover",
    "mousemove": "mousemove",
    "mouseleave": "mouseleave",
    "contextmenu": "contextmenu",
    "touchstart": "touchstart",
    "touchmove": "touchmove",
    "touchend": "touchend"
  },
  "chartElements": {
    "element": "Элемент",
    "legend-item": "Элемент легенды",
    "axis-label": "Название оси",
    "mask": "Маска",
    "plot": "Диаграмма",
    "legend-item-name": "Название элемента легенды",
    "reset-button": "Кнопка сброса"
  },
  "chartActions": {
    "openDashboard": "Открыть дашборд"
  },
  "StatusOverTimeWidget": {
    "title": "История Hi",
    "description": "История Hi",
    "nullHiHistory": "Нет данных по данным CI",
    "nullParsedData": "Обрабатываю данные"
  },
  "actions": {
    "openDashboard": "Дэшбоард ID"
  },
  "cyLayout": {
    "title": "Настройка расположения",
    "layout": "Схема расстановки"
  }
}